export default "__VITE_ASSET__5f20aabd__"